import { STATUS_STYLES, RESPONSE_TYPE_COLOR } from "../constants/pollOptions";

/** Coloured poll status pill, driven by STATUS_STYLES. */
export function StatusPill({ status, className = "" }) {
  const style = STATUS_STYLES[status] ?? STATUS_STYLES.Draft;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[13px] font-semibold whitespace-nowrap ${className}`}
      style={{ backgroundColor: style.bg, color: style.color }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: style.dot }} />
      {status}
    </span>
  );
}

/** Response Type pill — same shape as the announcements PriorityPill. */
export function ResponseTypePill({ responseType }) {
  const color = RESPONSE_TYPE_COLOR[responseType] ?? "var(--color-accent)";
  return (
    <span
      className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[12px] font-semibold whitespace-nowrap"
      style={{ backgroundColor: `color-mix(in srgb, ${color} 10%, transparent)`, color }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: color }} />
      {responseType}
    </span>
  );
}
